// Stack global de z-index para overlays (modales, etc.).
//
// Los overlays se quedan en su posicion original del DOM (dentro del
// div[data-controller]) para que Stimulus mantenga la conexion con los
// targets. El position:fixed + inset:0 ya los posiciona sobre el viewport
// sin importar donde esten en el arbol DOM.
//
// Cada open asigna un z-index incremental via style.zIndex para que el
// overlay mas reciente siempre quede encima del anterior:
//   z-index: 902, 904, 906, ...
//
// Uso desde controllers:
//   import { pushOverlay, popOverlay, topmostOverlay } from "./overlay_stack"
//
//   open()  { pushOverlay(this.overlayTarget) }
//   close() { popOverlay(this.overlayTarget) }

const BASE_Z = 900;
const STEP = 2;
let stack = [];

// Asigna z-index incremental y agrega al stack.
export function pushOverlay(overlayElement) {
  const z = BASE_Z + (stack.length + 1) * STEP;
  overlayElement.style.zIndex = z;
  stack.push(overlayElement);
  return z;
}

// Remueve del stack y limpia z-index.
export function popOverlay(overlayElement) {
  stack = stack.filter((el) => el !== overlayElement);
  overlayElement.style.zIndex = "";
}

// Retorna el overlay que esta mas arriba (ultimo del stack).
export function topmostOverlay() {
  return stack.length > 0 ? stack[stack.length - 1] : null;
}
